import { PageLoading } from 'module/ui/components/atoms/loading';
import { FC } from 'react';
import { AccountEmails } from 'components/organisms/email-pages';
import { AccountLayout } from '../common/layout';
import { AccountsTabs, AccountsTabsType } from '../common/tab';
import { useCompanyFromUrl } from '../use-current-company';

export const AccountEmailsPage: FC = () => {
  const { data: company, isLoading: isCompanyLoading } = useCompanyFromUrl();

  return isCompanyLoading || company == null ? (
    <PageLoading />
  ) : (
    <AccountLayout
      company={company}
      tabs={<AccountsTabs activeKey={AccountsTabsType.Email} />}
      content={<AccountEmails company={company} />}
      actions={{}}
    />
  );
};
